// UnsavedChangesConfirmationModal — stateless leaf extracted from
// ContactEditModal.tsx render body (Stage 2). Pure render of props: holds no
// useState/useEffect/useRef of its own. The orchestrator owns the
// `showUnsavedConfirmation` state and passes the dismiss/close callbacks.
// The Save button keeps the exact `.contact-save-btn` querySelector click
// contract — this component still renders inside the same modal portal DOM,
// so the selector resolves identically. DOM/markup byte-identical.
export function UnsavedChangesConfirmationModal({
  show,
  onDismiss,
  onClose,
}: {
  show: boolean;
  onDismiss: () => void;
  onClose: () => void;
}) {
  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2147483647, padding: 16,
    }} onClick={onDismiss}>
      <div style={{
        background: 'var(--color-surface)', borderRadius: 16, padding: 24, maxWidth: 320, width: '100%',
        boxShadow: '0 12px 32px rgba(0,0,0,0.2)', textAlign: 'center',
      }} onClick={e => e.stopPropagation()}>
        <p style={{ fontSize: 15, fontWeight: 500, color: 'var(--color-text)', margin: '0 0 6px' }}>Unsaved changes</p>
        <p style={{ fontSize: 13, color: '#4a4d51', margin: '0 0 20px', lineHeight: 1.5 }}>You have unsaved changes. Do you want to save before closing?</p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
          <button onClick={() => { onDismiss(); onClose(); }}
            style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #DADCE0', background: 'var(--color-surface)', fontSize: 13, cursor: 'pointer', color: '#4a4d51' }}>
            Discard
          </button>
          <button onClick={() => { onDismiss(); document.querySelector<HTMLButtonElement>('.contact-save-btn')?.click(); }}
            style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
